import { lazy, Suspense } from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import AdminPanelPage from "./pages/AdminPanelPage";

const GuestShell = lazy(() => import("./pages/GuestShell"));
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const LiveWallPage = lazy(() => import("./pages/LiveWallPage"));
const AlbumPage = lazy(() => import("./pages/AlbumPage"));
const FeedPage = lazy(() => import("./pages/FeedPage"));

const RESERVED = new Set(["admin", "panel", "create", "tables", "guests", "moderate", "api", "assets"]);

/** True when served from oila.lifegram.uz — routes live at / */
export function isOilaSubdomain(): boolean {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h.startsWith("oila.") || import.meta.env.VITE_OILA_STANDALONE === "true";
}

function SlugGuest({ base, tab }: { base: string; tab?: "home" | "profile" }) {
  const { slug = "" } = useParams();
  if (RESERVED.has(slug.toLowerCase())) {
    return <Navigate to={`${base}/admin`} replace />;
  }
  return <GuestShell slug={slug} initialTab={tab || "home"} />;
}

function SlugDashboard({ basePath }: { basePath: string }) {
  const { slug = "" } = useParams();
  return <DashboardPage slug={slug} basePath={basePath} />;
}

function SlugLive() {
  const { slug = "" } = useParams();
  return <LiveWallPage slug={slug} />;
}

function SlugAlbum() {
  const { slug = "" } = useParams();
  return <AlbumPage slug={slug} />;
}

export default function OilaApp() {
  const standalone = isOilaSubdomain();
  const base = standalone ? "" : "/oila";

  return (
    <Suspense
      fallback={
        <div className="oila-root min-h-screen flex items-center justify-center text-[#a09585]">
          Yuklanmoqda...
        </div>
      }
    >
      <Routes>
        {standalone && <Route path="/" element={<Navigate to="/admin" replace />} />}
        <Route path={`${base}/admin`} element={<AdminPanelPage />} />
        <Route path={`${base}/panel`} element={<Navigate to={`${base}/admin`} replace />} />
        <Route path={`${base}/create`} element={<Navigate to={`${base}/admin`} replace />} />
        <Route path={`${base}/tables`} element={<Navigate to={`${base}/admin`} replace />} />
        <Route path={`${base}/guests`} element={<Navigate to={`${base}/admin`} replace />} />
        <Route path={`${base}/moderate`} element={<Navigate to={`${base}/admin`} replace />} />

        <Route path={`${base}/:slug/feed`} element={<FeedPage />} />
        <Route path={`${base}/:slug/live`} element={<SlugLive />} />
        <Route path={`${base}/:slug/dashboard`} element={<SlugDashboard basePath={base} />} />
        <Route path={`${base}/:slug/albom`} element={<SlugAlbum />} />
        <Route path={`${base}/:slug/profile`} element={<SlugGuest base={base} tab="profile" />} />
        <Route path={`${base}/:slug`} element={<SlugGuest base={base} tab="home" />} />
      </Routes>
    </Suspense>
  );
}
